/**
 * Generates a unique identifier using the Web Crypto API.
 * This creates a cryptographically strong random UUID (v4) suitable for temporary/client-side entities.
 *
 * @returns A unique string identifier in UUID format
 * @example
 * const id = generateUniqueId();
 * // Returns something like: "9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d"
 */
export const generateUniqueId = (): string => crypto.randomUUID();

export const isValidUUID = (id?: string | null): boolean => {
  if (!id) return false;
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id);
};
